export const viewProfileTranslations = {
  en: {
    view_profile: "View Profile",
    basic_details: "Basic Detail",
    fighter_details: "Fighter Details",
    fight_history: "Fight History",
    achievements: "Achievements",
    video_url: "Video URL",
    youtube_links: "YouTube Links",
    nationality: "Nationality",
    residence_country: "Residence Country",
    phone: "Phone",
    region: "Region",
    profile_status: "Profile Status",
    verified: "Verified",
    organization_name: "Organization Name",
    bio: "Bio",
    nickname: "Nickname",
    date_of_birth: "Date of Birth",
    stance: "Stance",
    height: "Height",
    weight: "Weight",
    reach: "Reach",
    team: "Team",
    gym: "Gym",
    title_holder: "Title Holder",
    training_disciplines: "Training Disciplines",
    weight_classes: "Weight Classes",
    fight_style_description: "Fight Style Description",
    opponent: "Opponent",
    date: "Date",
    result: "Result",
    round: "Round",
    location: "Location",
    organization: "Organization",
    type_of_ending: "Type Of Ending",
    rule_set: "Rule Set",
    no_fight_history: "No fight history available.",
    no_achievements: "No achievements available.",
    no_video_url: "No video URL available.",
    no_youtube_links: "No YouTube links available.",
    title: "Title",
    description: "Description",
    invalid_youtube_url: "Invalid YouTube URL",
    edit_profile: "Edit Profile"
  },
  de: {
    view_profile: "Profil anzeigen",
    basic_details: "Grundlegende Details",
    fighter_details: "Kämpferdetails",
    fight_history: "Kampfhistorie",
    achievements: "Erfolge",
    video_url: "Video-URL",
    youtube_links: "YouTube-Links",
    nationality: "Nationalität",
    residence_country: "Wohnsitzland",
    phone: "Telefon",
    region: "Region",
    profile_status: "Profilstatus",
    verified: "Verifiziert",
    organization_name: "Organisationsname",
    bio: "Biografie",
    nickname: "Spitzname",
    date_of_birth: "Geburtsdatum",
    stance: "Kampfstellung",
    height: "Größe",
    weight: "Gewicht",
    reach: "Reichweite",
    team: "Team",
    gym: "Fitnessstudio",
    title_holder: "Titelträger",
    training_disciplines: "Trainingsdisziplinen",
    weight_classes: "Gewichtsklassen",
    fight_style_description: "Kampfstilbeschreibung",
    opponent: "Gegner",
    date: "Datum",
    result: "Ergebnis",
    round: "Runde",
    location: "Ort",
    organization: "Organisation",
    type_of_ending: "Art des Abschlusses",
    rule_set: "Regelwerk",
    no_fight_history: "Keine Kampfhistorie verfügbar.",
    no_achievements: "Keine Erfolge verfügbar.",
    no_video_url: "Keine Video-URL verfügbar.",
    no_youtube_links: "Keine YouTube-Links verfügbar.",
    title: "Titel",
    description: "Beschreibung",
    invalid_youtube_url: "Ungültige YouTube-URL",
    edit_profile: "Profil bearbeiten"
  },
  hr: {
    view_profile: "Pogledaj profil",
    basic_details: "Osnovni detalji",
    fighter_details: "Detalji borca",
    fight_history: "Povijest borbi",
    achievements: "Postignuća",
    video_url: "Video URL",
    youtube_links: "YouTube poveznice",
    nationality: "Nacionalnost",
    residence_country: "Država prebivališta",
    phone: "Telefon",
    region: "Regija",
    profile_status: "Status profila",
    verified: "Verificiran",
    organization_name: "Naziv organizacije",
    bio: "Biografija",
    nickname: "Nadimak",
    date_of_birth: "Datum rođenja",
    stance: "Stav",
    height: "Visina",
    weight: "Težina",
    reach: "Domet",
    team: "Tim",
    gym: "Teretana",
    title_holder: "Nositelj titule",
    training_disciplines: "Discipline treninga",
    weight_classes: "Težinske klase",
    fight_style_description: "Opis stila borbe",
    opponent: "Protivnik",
    date: "Datum",
    result: "Rezultat",
    round: "Runda",
    location: "Lokacija",
    organization: "Organizacija",
    type_of_ending: "Vrsta završetka",
    rule_set: "Skup pravila",
    no_fight_history: "Nema dostupne povijesti borbi.",
    no_achievements: "Nema dostupnih postignuća.",
    no_video_url: "Nema dostupnog video URL-a.",
    no_youtube_links: "Nema dostupnih YouTube poveznica.",
    title: "Naslov",
    description: "Opis",
    invalid_youtube_url: "Nevažeći YouTube URL",
    edit_profile: "Uredi profil"
  }
};